/* Perfectly Cordial 2026 theme: recipe blog filter.
   Ported from the preview's app.js (recipe index filter). Pills inside
   [data-pc-recipes] filter the [data-pc-recipes-grid] cards by the tag keys
   in each card's data-tags. The pill row ships with the hidden attribute, so
   with no JS the full grid shows and there are no dead controls. Counts are
   computed from the cards on the page, so a new recipe never needs a number
   updated anywhere. Pressed state and a live status line are kept for
   keyboard and screen reader users. */
(function () {
  "use strict";

  function setup(root) {
    var grid = root.querySelector("[data-pc-recipes-grid]") ||
      document.querySelector("[data-pc-recipes-grid]");
    if (!grid || root.getAttribute("data-pc-recipes-ready") === "true") return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll(".rec-card"));
    var pills = Array.prototype.slice.call(root.querySelectorAll("[data-pc-rf]"));
    var status = root.querySelector("[data-pc-rf-status]");
    var one = root.getAttribute("data-status-one") || "1 recipe shown";
    var many = root.getAttribute("data-status-many") || "[count] recipes shown";

    var match = function (card, key) {
      if (key === "all") return true;
      var tags = (card.getAttribute("data-tags") || "").split(/\s+/);
      return card.getAttribute("data-flavor") === key || tags.indexOf(key) !== -1;
    };

    pills.forEach(function (pill) {
      var key = pill.getAttribute("data-pc-rf");
      var n = cards.filter(function (c) { return match(c, key); }).length;
      var badge = pill.querySelector(".rf-n");
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "rf-n";
        badge.setAttribute("aria-hidden", "true");
        pill.appendChild(badge);
      }
      badge.textContent = String(n);
      pill.addEventListener("click", function () {
        pills.forEach(function (p) {
          p.classList.toggle("on", p === pill);
          p.setAttribute("aria-pressed", p === pill ? "true" : "false");
        });
        var shown = 0;
        cards.forEach(function (c) {
          var ok = match(c, key);
          c.hidden = !ok;
          if (ok) shown++;
        });
        if (status) status.textContent = shown === 1 ? one : many.replace("[count]", String(shown));
      });
    });

    root.hidden = pills.length < 2;
    root.setAttribute("data-pc-recipes-ready", "true");
  }

  function init() {
    document.querySelectorAll("[data-pc-recipes]").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* The theme editor re-renders the section in place. */
  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll("[data-pc-recipes]").forEach(setup);
  });
})();
